import styles from './Account.module.css';

/** Page-level heading shown above the cards in each tab. */
export default function SectionHead({ title, subtitle }) {
  return (
    <div className={styles.sectionHead}>
      <h1 className={styles.sectionTitle}>{title}</h1>
      {subtitle && <p className={styles.sectionSub}>{subtitle}</p>}
    </div>
  );
}
